import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import Order from '../../../smoothr-web-app-core/models/Order';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { numberToCurrency } from 'src/smoothr-web-app-core/utils/utils';
import { NavigationService } from 'src/app/services/navigation.service';
import Venue from 'src/smoothr-web-app-core/models/Venue';

@Component({
	selector: 'app-to-order-button',
	templateUrl: './to-order-button.component.html',
	styleUrls: ['to-order-button.component.scss'],
})
export class ToOrderButtonComponent {
	price = 0;
	formattedPrice = '';
	active = false;

	private _order: Order;

	get order(): Order {
		return this._order;
	}

	@Input() set order(value: Order) {
		this._order = value;
		this.price = this.calculatePrice();
		this.formattedPrice = this.generateFormattedPrice();
		this.active = this.isActive();
	}

	private _venue: Venue;

	get venue(): Venue {
		return this._venue;
	}

	@Input() set venue(value: Venue) {
		this._venue = value;
		this.price = this.calculatePrice();
		this.formattedPrice = this.generateFormattedPrice();
		this.active = this.isActive();
	}

	constructor(
		private router: Router,
		private navigationService: NavigationService
	) {}

	private calculatePrice(): number {
		if (!this.order || !this.venue) {
			return 0;
		}
		// Fix: Check if preorder exists before accessing its properties
		if (!this.order.preorder) {
			return 0;
		}
		let mappedOrder = structuredClone(this.order);

		const foundArticleIndex = this.order.orderedArticles.findIndex(it => it?.isHalfPizza);
		if (foundArticleIndex >= 0) {
			const foundArticle = this.venue.articleCategories
				.map(it => it?.articles?.find(ar => ar?.tags?.find(tag => tag?.identifier == 'appliesMostExpensive')))
				.filter(it => !!it);

			if (foundArticle.length > 0) {
				mappedOrder.orderedArticles = mappedOrder.orderedArticles.map(it => {
					if (it.isHalfPizza) {
						it.article = foundArticle[0];
					}
					return it;
				});
			}
		}
		return OrderUtils.articleGroupsTotalPrice(
			mappedOrder.orderedArticles,
			mappedOrder.type,
			mappedOrder.preorder?.type,
			mappedOrder.terminalorder ? mappedOrder.terminalorder.type : null
		);
	}

	private generateFormattedPrice(): string {
		// Fix: Use default currency if not set
		const currency = this.order?.currency || 'EUR';
		return numberToCurrency(this.price, currency);
	}

	private isActive(): boolean {
		return this.price > 0;
	}

	async goToOrder() {
		if (this.active) {
			await this.navigationService.order();
		}
	}
}
